import { NumericRangeType } from '@decisions/server/DecisionsFramework/Design/Page/Filters';
import { IActionLinkItem } from 'components/ActionLinks/ActionLinkModels';

export const DEFAULT_NUMERIC_MATCH_TYPE_LABELS = new Map([
  [NumericRangeType.Above, 'Above'],
  [NumericRangeType.Between, 'Between'],
  [NumericRangeType.Below, 'Below'],
  [NumericRangeType.Equals, 'Equals'],
]);

export function getNumericRangeOptions(): IActionLinkItem[] {
  
  // TODO translation of these?
  return Array.from(DEFAULT_NUMERIC_MATCH_TYPE_LABELS.keys()).map(value => ({
    value,
    label: getLabelForNumericMatchType(value),
  }));
}

export function getNumericFieldOptions(): IActionLinkItem[] {
  return Array.from(DEFAULT_NUMERIC_MATCH_TYPE_LABELS.keys())
  .filter(value => value !== NumericRangeType.Between)
  .map(value => ({
    value,
    label: getLabelForNumericMatchType(value),
  }));
}

export function getLabelForNumericMatchType(type: NumericRangeType) {
  return DEFAULT_NUMERIC_MATCH_TYPE_LABELS.get(type) as string;
}

// function getStringsFromRange({ Above, Below, Value }: NumericRange) {
//   return {
//     above: Above.toString(),
//     below: Below.toString(),
//     equals: Value.toString(),
//   };
// }

// function fillRangeFromStrings({ above, below, equals }: IEditingRangeStrings, range: NumericRange) {
//   range = { ...range };
//   range.Above = parseFloat(above);
//   range.Below = parseFloat(below);
//   range.Value = parseFloat(equals);
//   return range;
// }
